import React, { useState } from 'react';

// Import all the tab components
import SummaryTab from './tabs/SummaryTab';
import TreatmentPlanTab from './tabs/TreatmentPlanTab'; 
import PathogensTab from './tabs/PathogensTab';
import ResistanceTab from './tabs/ResistanceTab';
import MonitoringTab from './tabs/MonitoringTab';
import ConsiderationsTab from './tabs/ConsiderationsTab';
import DashboardTab from './tabs/DashboardTab';

// Tab names constant for easy modification
const TABS = [
  { id: 'summary', label: 'SUMMARY' },
  { id: 'treatment-plan', label: 'TREATMENT PLAN' },
  { id: 'pathogens', label: 'PATHOGENS' },
  { id: 'resistance', label: 'RESISTANCE' },
  { id: 'monitoring', label: 'MONITORING' },
  { id: 'considerations', label: 'CONSIDERATIONS' },
  { id: 'dashboard', label: 'DASHBOARD' }
];

interface ReportTabsProps {
  reportData?: any;
  initialTab?: string;
}

const ReportTabs: React.FC<ReportTabsProps> = ({ reportData, initialTab = 'summary' }) => {
  const [activeTab, setActiveTab] = useState<string>(initialTab);

  return (
    <div className="w-full">
      {/* Tabs header */}
      <div className="flex flex-wrap border-b">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`px-2 sm:px-4 py-2 font-medium text-xs sm:text-sm ${
              activeTab === tab.id
                ? 'text-primary border-b-2 border-primary '
                : 'text-gray-500 hover:text-primary'
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="mt-4">
        {activeTab === 'summary' && <SummaryTab reportData={reportData} />}
        
        {activeTab === 'treatment-plan' && <TreatmentPlanTab reportData={reportData} />}
        
        {activeTab === 'pathogens' && <PathogensTab reportData={reportData} />}
        
        {activeTab === 'resistance' && <ResistanceTab reportData={reportData} />}
        
        {activeTab === 'monitoring' && <MonitoringTab reportData={reportData} />}
        
        {activeTab === 'considerations' && <ConsiderationsTab reportData={reportData} />}
        
        {activeTab === 'dashboard' && <DashboardTab reportData={reportData} />}
      </div>
    </div>
  );
};

export default ReportTabs; 